import { AdminMembersReportPageStartDate } from "@/admin/insights/member-reports/AdminMembersReportPage"
import AdminMembersReportProductsTable from "@/admin/insights/member-reports/tabs/products/AdminMembersReportProductsTable"
import AdminMembersReportProductsTabStatisticsCards from "@/admin/insights/member-reports/tabs/products/AdminMembersReportProductsTabStatisticsCards"
import { useActiveOrganization } from "@/core/context/ActiveOrganizationContext"
import useFeatureFlags from "@utils/hook/useFeatureFlags"

interface AdminMembersReportPageProductsTabProps {
  startDate: AdminMembersReportPageStartDate
}

function AdminMembersReportPageProductsTab({
  startDate,
}: AdminMembersReportPageProductsTabProps) {
  const { learningPathways } = useFeatureFlags()
  const activeOrganization = useActiveOrganization()!
  const showPathways =
    learningPathways &&
    (activeOrganization.viewerPermissions.has("pathways.manage") ||
      activeOrganization.viewerMembership?.hasGroupLeadRole)

  return (
    <>
      <AdminMembersReportProductsTabStatisticsCards filters={{ startDate }} />
      {showPathways && <AdminMembersReportProductsTable productType={"pathway"} />}
      <AdminMembersReportProductsTable />
    </>
  )
}

export default AdminMembersReportPageProductsTab
